import {QRCodeSVG} from 'qrcode.react';
import Menu from "../../component/Menu";
import {useRouter} from 'preact-router'
import classes from '../../styles/index.module.css';
import downloadClasses from '../../styles/download.module.css';
import gongan from '../../assets/gongan.png'
import Image from '../../component/Image'
import {requestGet} from '../../utils/request';
import phone_i from '../../assets/phone_i.png';
import phone_c from '../../assets/phone_c.png';
import phone_e from '../../assets/phone_e.png';
import phone_q from '../../assets/phone_q.png';
import android from '../../assets/android.png';
import banner_i from '../../assets/banner_i.png';
import banner_e from '../../assets/banner_e.png';
import banner_c from '../../assets/banner_c.png';
import banner_q from '../../assets/banner_q.png';
import ios from '../../assets/ios.png';
import {useEffect, useState} from "preact/hooks";
import android_code from '../../assets/android_code.png'
import ios_code from '../../assets/ios_code.png'

const images = {
	'1': {
		title: '极安企业端app下载页',
		phone: phone_q,
		banner: banner_q,
		android_png: 'company_app.png',
		ios_png: 'company_ios.png',
		ios_id: 'id1402429370',
		title1: '把安全随身携带',
		des1: '远离事故风险',
		des2: '拥抱极致安全'
	},
	'5': {
		title: '极安专家端app下载页',
		phone: phone_e,
		banner: banner_e,
		android_png: 'expert_app.png',
		ios_png: 'expert_ios_app.png',
		ios_id: 'id1455296594',
		title1: '让技术产生价值',
		des1: '汇聚社会专业力量',
		des2: '护航企业安全生产'
	},
	'10': {
		title: '极安安全胶囊app下载页',
		phone: phone_c,
		banner: banner_c,
		android_png: 'cap_android.png',
		ios_png: 'cap_ios.png',
		ios_id: 'id1458307129',
		title1: '让安全成为一种习惯',
		des1: '提供安全知识',
		des2: '助你专业成长'
	},
	'23': {
		title: '极安保险端app下载页',
		phone: phone_i,
		banner: banner_i,
		android_png: 'insur_android.png',
		ios_png: 'insur_ios.png',
		ios_id: 'id1457190304',
		title1: '极安在手',
		title2: '风控无忧',
		des1: '共创安责险互联网新生态'
	}
}

async function getDownloadUrl(context) {
	const terminalID = context?.id;
	console.log('ermfid',terminalID)
	if (terminalID == '10') {
		return `${process.env.PREACT_APP_BUNDLE_URL}/jeeancap/jeeancap.apk`
	} else {
		const res =await requestGet(process.env.PREACT_APP_BASE_URL, '/app/latest/download/url', {terminalID: context?.id});
		const data = res.data;
		console.log('data.url',data.url)
		return data?.url
	}
}

export default function DownLoad() {
	const [{matches}] = useRouter();

	const [androidUrl, setUrl] = useState('');

	const [download_url,set_download_url] = useState('');
	const image_data = images[matches?.id];
	useEffect(() => {

		setUrl(location.origin);

		getDownloadUrl(matches).then(url=>{
			console.log('url',url)
			set_download_url(url)
		});

	}, [matches.id]);

	return (
		<div>
			<title>{image_data?.title}</title>
			<header className={classes.header}>
				<div className={classes.logo}>
					<Image width={100} height={40}
					       src={`${process.env.PREACT_APP_STATIC_URL}/jeean-logo/jeean-cloud-logo-gov.svg`}
					       alt=""/>
				</div>
				<Menu
					scrollTo={false}
					defaultSelectedKeys={matches?.id}
					items={[
						{
							key: '23',
							label: <a href="/downloadapp/23">保险端</a>
						},
						{
							key: '5',
							label: <a href="/downloadapp/5">专家端</a>
						},
						{
							key: '1',
							label: <a href="/downloadapp/1">企业端</a>
						},
						{
							key: '10',
							label: <a href="/downloadapp/10">安全胶囊</a>
						}
					]}
				/>
			</header>
			<main className={classes.content}>
				<div className={downloadClasses['wrap']}>
					<Image className={downloadClasses['back']}
					       width="100%"
					       height="100%"
					       alt=""
					       priority
					       src={image_data?.banner}
					       style={{
						       zIndex: '-1'
					       }}
					/>
					<div className={downloadClasses['content']}>
						<div className={downloadClasses['contentLeft']}>
							<p className={downloadClasses['word_p']}>
								<span className={downloadClasses['word_top--left']}>{image_data?.title1}</span>
								{
									image_data?.title2 &&
									<span className={downloadClasses['word_top--right']}>{image_data?.title2}</span>
								}
							</p>
							<p className={downloadClasses['word_p']}>
								<span className={downloadClasses['word_bottom--left']}>{image_data?.des1}</span>
								{
									image_data?.des2 &&
									<span className={downloadClasses['word_bottom--right']}>{image_data?.des2}</span>
								}
							</p>
							<div className={downloadClasses['spaceContent']}>

								<div
									className={downloadClasses['spaceVertical']}
									style={{
										marginRight: '5%'
									}}
								>
									<button
										className={downloadClasses['QRCodeButton']}
									>
										<a className={downloadClasses['buttonA']} href={download_url}>
											<div className={downloadClasses['buttonImage']}>
												<Image
													src={android}
													priority
													alt=""
												/>
											</div>
											Android
										</a>
									</button>
									<div className={downloadClasses['QRCodeBox']}>
										<QRCodeSVG
											size={160}
											errorLevel="H"
											value={androidUrl + '/Download/mobile/' + matches?.id}
											imageSettings={{
												src: {android_code},
												width: 40,
												height: 40
											}}
										/>
									</div>
								</div>
								<div className={downloadClasses['spaceVertical']}>
									<button
										className={downloadClasses['QRCodeButton']}
									>
										<a className={downloadClasses['buttonA']}
										   href={`${process.env.PREACT_APP_PUBLIC_ITUNES_URL}/${image_data?.ios_id}`}
										>
											<div className={downloadClasses['buttonImage']}>
												<Image
													src={ios}
													priority
													alt=""
												/>
											</div>
											iOS
										</a>
									</button>
									<div className={downloadClasses['QRCodeBox']}>
										<QRCodeSVG
											size={160}
											errorLevel="H"
											value={`${process.env.PREACT_APP_PUBLIC_ITUNES_URL}/${image_data?.ios_id}`}
											imageSettings={{
												src: {ios_code},
												width: 40,
												height: 40
											}}
										/>
									</div>
								</div>
							</div>
						</div>
						<div className={downloadClasses['contentRight']}>
							<Image alt="" width={304} height={439} className="phone_img" src={image_data?.phone}/>
						</div>
					</div>
					<div className={downloadClasses['footer']}>
						<span>©2015-2017 北京星度科技有限公司 all Right reserved |</span>
						<a type="link" target="_blank"
						   href="http://beian.miit.gov.cn">京ICP备14031847-1</a>

						<Image height={20} src={gongan} alt=""/>
						<a type="link" target="_blank"
						   href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010502042659">
							京公网安备 11010502042659
						</a>
					</div>
				</div>
			</main>
		</div>
	)
}
